import * as React from 'react'

import TextField, { defaultTextFieldProps } from './BaseTextField'
import { ITextFieldProps } from './types'

interface IProps extends ITextFieldProps {
  onChange: (value: string) => void
}

const cleaveOptions = {
  blocks: [5],
  numericOnly: true,
}

function PostalCodeTextField(props: IProps) {
  const { onChange, ...moreProps } = props

  return (
    <TextField
      {...moreProps}
      autoComplete="postal-code"
      cleaveOptions={cleaveOptions}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
    />
  )
}

PostalCodeTextField.defaultProps = defaultTextFieldProps

export default React.memo(PostalCodeTextField)
